var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAltinn = function SvgAltinn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#0062BA",
    viewBox: "0 0 29 29"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.883 0H.587A.59.59 0 0 0 0 .586v27.828A.585.585 0 0 0 .587 29h14.296a14.54 14.54 0 0 0 10.006-4.388A14.48 14.48 0 0 0 29 14.506c0-3.774-1.475-7.4-4.11-10.106A14.54 14.54 0 0 0 14.882.012zm1.398 24.628a10.36 10.36 0 0 1-6.354-.929 10.33 10.33 0 0 1-4.578-4.493 10.3 10.3 0 0 1 1.87-12.038 10.356 10.356 0 0 1 12.063-1.866 10.33 10.33 0 0 1 4.502 4.57 10.3 10.3 0 0 1-1.947 11.884 10.34 10.34 0 0 1-5.556 2.872"
  })));
};
export default SvgAltinn;